import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Blocker from "../../Misc/Blocker";
import CrewShipSelect from "./CrewShipSelect";
import DefaultNotFound from "../../Misc/DefaultNotFound";

export default class Crew extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      crew: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.load();
    }
  }

  load = async () => {
    let crew = [];
    const { shipId } = this.props;
    if (shipId) {
      this.setState({ pending: true });
      let ship = await this.context.api.q("/ship/get", { id: shipId });
      if (ship) {
        if (ship.area) {
          crew = await this.context.api.qa("/staff/list", {
            filter: { area: ship.area },
            orderby: ["label ASC"],
          });
        }
      }
    }
    this.setState({ pending: false, crew });
  };

  onToggle = async (item) => {
    if (item) {
      this.setState({ pending: true });
      let result = await this.context.api.q("/staff/set", {
        id: item.id,
        ship: item.ship ? this.context.api.nullUuid : this.props.shipId,
      });
      if (result !== false) {
        await this.load();
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }
      this.setState({ pending: false });
    }
  };

  render() {
    const { shipId, embed } = this.props;
    const { pending, crew } = this.state;
    return (
      <>
        <div className={embed ? "" : "container"}>
          {!embed && (
            <div className="mb-5">
              <CrumbsProvider title="Экипаж" link="/crew/" />
              <CrewShipSelect shipId={shipId} />
            </div>
          )}

          <Blocker on={pending}>
            {!crew.length && (
              <DefaultNotFound message={"Сведения об экипаже отсутствуют"} />
            )}
            {crew.length > 0 && (
              <div className="card card-custom">
                <div className="card-body px-5">
                  {crew.map((item) => {
                    return (
                      <div key={item.id} className="py-3 border-bottom">
                        <span className="mr-2">
                          <input
                            onChange={() => this.onToggle(item)}
                            checked={item.ship === shipId ? true : false}
                            type="checkbox"
                          />
                        </span>
                        <span
                          className={`${
                            item.ship === shipId ? "text-dark" : "text-dark-50"
                          }`}
                        >
                          {item.label}
                        </span>
                        <span className="ml-2 small text-muted">
                          {item.positionname}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Blocker>
        </div>
      </>
    );
  }
}
